import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { IAdminProfileSite } from '../models/IAdminProfile';
import { showAdminProfileSiteManagementDialog } from '../services/AdminProfileSiteManagementDialogAction';

export interface AdminProfileSiteManagementButtonProps {
  profileId: string;
  profileName: string;
  sites: ReadonlyArray<IAdminProfileSite>;
  onProfileSitesUpdated?: () => void;
}

/**
 * Button that opens the Admin Profile Site Management dialog.
 */
export const AdminProfileSiteManagementButton: React.FC<AdminProfileSiteManagementButtonProps> = ({
  profileId,
  profileName,
  sites,
  onProfileSitesUpdated,
}) => (
  <ButtonWidget
    buttonType={ButtonType.Outline}
    onClick={() => showAdminProfileSiteManagementDialog(profileId, profileName, sites, onProfileSitesUpdated)}
    testId="admin-profile-site-management-button"
  >
    {Messages.adminProfileSiteManagementButton()}
  </ButtonWidget>
);
